import React, { useState, useRef, useEffect } from "react";
import "./AdminShared.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

const AddProduct = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    description: "",
    category: "",
    stock: "",
    features: "",
    specifications: "",
    image: null,
  });

  const [submitting, setSubmitting] = useState(false);
  const [preview, setPreview] = useState(null);

  // 🔐 SECURITY CHECK
  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) navigate("/admin");
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files.length > 0) {
      setFormData({ ...formData, image: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const data = new FormData();
    const feat = formData.features.split("\n").map(x => x.trim()).filter(Boolean);
    const spec = formData.specifications.split("\n").map(x => x.trim()).filter(Boolean);

    // Append normal fields
    data.append("name", formData.name);
    data.append("price", formData.price);
    data.append("description", formData.description);
    data.append("category", formData.category);
    data.append("stock", formData.stock);
    data.append("features", JSON.stringify(feat));
    data.append("specifications", JSON.stringify(spec));
    if (formData.image) data.append("image", formData.image);

    try {
      const res = await fetch(`${API_BASE_URL}/api/products`, { method: "POST", body: data });
      if (res.ok) {
        alert("✅ Hardware asset successfully logged.");
        navigate("/admin/panel");
      } else throw new Error("Log failed");
    } catch (error) { alert("❌ System error"); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Product Ledger</h1>
        </div>
        <div className="module-badge">New Asset</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
           <div className="admin-user-tag">
              <div className="dot" style={{ background: '#6366f1' }}></div>
              Operator: Inventory Management Node
           </div>
        </div>

        <div className="admin-table-wrapper" style={{ padding: '40px', background: '#fff' }}>
           <form className="admin-form-elite" onSubmit={handleSubmit}>
              <label>Product Identity <input type="text" name="name" value={formData.name} onChange={handleChange} required /></label>
              <label>Market Valuation (INR) <input type="number" name="price" value={formData.price} onChange={handleChange} required /></label>
              <label className="full-width-field">Market Description <textarea name="description" value={formData.description} onChange={handleChange} required /></label>
              <label>Operational Category <input type="text" name="category" value={formData.category} onChange={handleChange} required /></label>
              <label>Available Units (Stock) <input type="number" name="stock" value={formData.stock} onChange={handleChange} required /></label>
              <label>Feature Payload (one per line) <textarea name="features" value={formData.features} onChange={handleChange} /></label>
              <label>Technical Specifications (one per line) <textarea name="specifications" value={formData.specifications} onChange={handleChange} /></label>
              <label className="full-width-field">Primary Asset Visual <input type="file" name="image" onChange={handleChange} ref={fileInputRef} accept="image/*" /></label>
              
              {preview && (
                  <div className="img-preview-box full-width-field" style={{ marginTop: '20px' }}>
                      <img src={preview} alt="Preview" style={{ maxWidth: "240px", borderRadius: '12px', border: '1px solid #e2e8f0' }} />
                  </div>
              )}

              <div className="admin-submit-area">
                <button type="submit" className="btn-primary-elite" disabled={submitting}>
                    {submitting ? "Logging Asset..." : "DEPLOY PRODUCT"}
                </button>
              </div>
           </form>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
